export const convertPlanName = current_plan_name => {
  if (current_plan_name?.includes('starter')) {
    return 'starter_monthly';
  }
  if (current_plan_name?.includes('growth')) {
    return 'growth_monthly';
  }
  if (current_plan_name?.includes('scale')) {
    return 'scale_monthly';
  }
  if (current_plan_name?.includes('superstarter_monthly')) {
    return 'superstarter_monthly';
  }
  if (current_plan_name?.includes('community')) {
    return 'community_monthly';
  }
  if (current_plan_name?.includes('Pro')) {
    return 'scale_monthly';
  }

  return 'community_monthly';
};
